const swiper = new Swiper('.team-modal__swiper-container', {
	slidesPerView: 2,
	spaceBetween: 30,
	loop: false,
	// allow touchswiper
	touchStartPreventDefault: false,
	touchMoveStopPropagation: false,

	pagination: {
		el: '.team-modal__swiper-pagination',
		clickable: true,
	},
	navigation: {
		nextEl: '.controls__button--next',
		prevEl: '.controls__button--prev',
	},
	breakpoints: {
		768: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
		1024: {
			slidesPerView: 4,
			spaceBetween: 30,
		},
	},
});

const teamMembers = document.querySelectorAll('.team-member');
const teamMembersModalItems = document.querySelectorAll('.team-modal__item');
const teamMembersSwiperSlides = document.querySelectorAll('.team-modal__swiper-slide');
const teamMembersModalItemContainer = document.querySelector('.team-modal__items');
let activeTeamMemberModalItem;
let activeTeamMemberSwiperSlide;
let useHash = false;

// If body has the class page-id-718, use hash
if (document.body.classList.contains('page-id-718')) {
	console.log('using hash');
	useHash = true;
}

function toggleActiveTeamMemberModalItem(index) {
	if (activeTeamMemberModalItem) {
		activeTeamMemberModalItem.classList.remove('team-modal__item--active');
	}

	if (activeTeamMemberSwiperSlide) {
		activeTeamMemberSwiperSlide.classList.remove('team-modal__swiper-slide--active');
	}

	teamMembersModalItems[index].classList.add('team-modal__item--active');
	teamMembersSwiperSlides[index].classList.add('team-modal__swiper-slide--active');
	activeTeamMemberModalItem = teamMembersModalItems[index];
	activeTeamMemberSwiperSlide = teamMembersSwiperSlides[index];

	if (useHash) {
		updateTeamHash(index);
	}

	slideToActiveTeamMemberItem(index);
	setTimeout(() => {
		resizeTeamMemberModalItems();
	}, 300);
}

function checkTeamHash() {
	const hash = window.location.hash.substring(1);
	console.log(hash);
	if (hash === '') return;
	const memberIndex = Array.from(teamMembers).findIndex(
		(member) => member.dataset.target.trim() === hash
	);
	console.log(memberIndex);
	if (memberIndex === null) return;

	toggleActiveTeamMemberModalItem(memberIndex);
}

function updateTeamHash(index) {
	if (useHash) {
		const hash = teamMembers[index].dataset.target;
		window.location.hash = hash.trim();
	}
}

function resizeTeamMemberModalItems() {
	teamMembersModalItemContainer.style.height = `${activeTeamMemberModalItem.offsetHeight}px`;
}

window.addEventListener('resize', () => {
	if (activeTeamMemberModalItem) {
		resizeTeamMemberModalItems();
	}
});

function slideToActiveTeamMemberItem(index) {
	swiper.slideTo(index);
	// scroll to the top of the modal if the user is on mobile
	setTimeout(() => {
		if (window.innerWidth < 768) {
			const modal = document.querySelector('.modal__header');
			// Use gsap
			gsap.to('.modal', {
				duration: 0.5,
				scrollTo: {
					y: modal,
					offsetY: 90,
				},
			});
		}
	}, 700);
}

checkTeamHash();

teamMembers.forEach((member, index) => {
	member.addEventListener('click', () => {
		toggleActiveTeamMemberModalItem(index);
	});
});

teamMembersSwiperSlides.forEach((slide, index) => {
	slide.addEventListener('click', () => {
		toggleActiveTeamMemberModalItem(index);
	});
});

// class Team {
// 	constructor(params) {
// 		this.swiper = new Swiper('.team-modal__swiper-container', {
// 			slidesPerView: 2,
// 			spaceBetween: 30,
// 			loop: false,
// 			touchStartPreventDefault: false,
// 			touchMoveStopPropagation: false,
// 			pagination: {
// 				el: '.team-modal__swiper-pagination',
// 				clickable: true,
// 			},
// 			navigation: {
// 				nextEl: '.controls__button--next',
// 				prevEl: '.controls__button--prev',
// 			},
// 			breakpoints: {
// 				768: {
// 					slidesPerView: 3,
// 					spaceBetween: 30,
// 				},
// 				1024: {
// 					slidesPerView: 4,
// 					spaceBetween: 30,
// 				},
// 			},
// 		});
// 		this.teamMemberWidget = params.teamMemberWidget;
// 		this.teamMembers = this.teamMemberWidget.querySelectorAll('.team-member');
// 		this.teamMembersModalItems = document.querySelectorAll('.team-modal__item');
// 		this.teamMembersSwiperSlides = document.querySelectorAll('.team-modal__swiper-slide');
// 		this.teamMembersModalItemContainer = document.querySelector('.team-modal__items');
// 		this.activeTeamMemberModalItem;
// 		this.activeTeamMemberSwiperSlide;
// 		// Select the parent modal element
// 		this.teamMembers.forEach((member, index) => {
// 			member.addEventListener('click', () => {
// 				this.toggleActiveTeamMemberModalItem(index);
// 			});
// 		});

// 		this.teamMembersSwiperSlides.forEach((slide, index) => {
// 			slide.addEventListener('click', () => {
// 				this.toggleActiveTeamMemberModalItem(index);
// 			});
// 		});

// 		window.addEventListener('resize', () => {
// 			if (this.activeTeamMemberModalItem) {
// 				this.resizeTeamMemberModalItems();
// 			}
// 		});
// 	}

// 	toggleActiveTeamMemberModalItem(index) {
// 		if (this.activeTeamMemberModalItem) {
// 			this.activeTeamMemberModalItem.classList.remove('team-modal__item--active');
// 		}

// 		if (this.activeTeamMemberSwiperSlide) {
// 			this.activeTeamMemberSwiperSlide.classList.remove('team-modal__swiper-slide--active');
// 		}

// 		this.teamMembersModalItems[index].classList.add('team-modal__item--active');
// 		this.teamMembersSwiperSlides[index].classList.add('team-modal__swiper-slide--active');
// 		this.activeTeamMemberModalItem = this.teamMembersModalItems[index];
// 		this.activeTeamMemberSwiperSlide = this.teamMembersSwiperSlides[index];

// 		this.slideToActiveTeamMemberItem(index);
// 		setTimeout(() => {
// 			this.resizeTeamMemberModalItems();
// 		}, 300);
// 	}

// 	resizeTeamMemberModalItems() {
// 		this.teamMembersModalItemContainer.style.height = `${this.activeTeamMemberModalItem.offsetHeight}px`;
// 	}

// 	slideToActiveTeamMemberItem(index) {
// 		this.swiper.slideTo(index);
// 		setTimeout(() => {
// 			if (window.innerWidth < 768) {
// 				const modal = document.querySelector('.modal__header');
// 				gsap.to('.modal', {
// 					duration: 0.5,
// 					scrollTo: {
// 						y: modal,
// 						offsetY: 90,
// 					},
// 				});
// 			}
// 		}, 700);
// 	}
// }

// const teamMemberWidgets = document.querySelectorAll('.team-members');

// teamMemberWidgets.forEach(teamMemberWidget => {
// 	const team = new Team({ teamMemberWidget: teamMemberWidget });
// });
